Namespace 'Customer.Dashboard'

class Customer.Dashboard.TicketSummaryView extends Backbone.View
  template: JST['backbone/templates/customer/dashboard/summary/main/body/ticket_summary']
  className: 'ticket-summary unselectable'
  events:
    'click .checkbox-icon': 'toggleSelectTicket'
    'change .checkbox-icon': 'toggleDisplayTicketAsSelected'
    'dblclick .summary-box': 'openTicket'
    'click .summary-open-ticket-button': 'openTicket'
    'click .attachment-scroll-backwards': '_scrollAttachmentsBackwards'
    'click .attachment-scroll-forwards': '_scrollAttachmentsForwards'

  initialize: ({ticketSummary}) ->
    @ticketSummary = ticketSummary
    @listenTo @ticketSummary, 'change', @render

  render: ->
    @trigger('counters:find:spin')
    @$el.html(@template({
      borderColor: @_borderColor()
      canUpdateAll: Keepcon.current_user.canUpdateAll
      checked: @ticketSummary.get('selected')
    }))
    @_renderAvatarView()
    @_renderAuthorView()
    @_renderDetailView()
    @_renderTextView()
    @_addReviewView() if @ticketSummary.get('summary_type') == 'review'
    @_addInstagramMessageUnsupportedIcon() if @ticketSummary.isInstagramMessageUnsupported()
    setTimeout =>
      @_displayAttachmentScroll()
    , 500
    @trigger('counters:find:stop')
    @

  _renderAvatarView: ->
    @$('.summary-avatar-container').html(
      new Customer.Dashboard.TicketSummaryAvatarView(
        ticketSummary: @ticketSummary
      ).render().el
    )

  _renderAuthorView: ->
    @$('.summary-author-container').html @_authorView().render().el

  _authorView: ->
    if @ticketSummary.get('summary_type') == 'email'
      new Customer.Dashboard.TicketSummaryEmailAuthorView
        ticketSummary: @ticketSummary
    else
      new Customer.Dashboard.TicketSummaryAuthorView
        ticketSummary: @ticketSummary

  _renderDetailView: ->
    @$('.summary-detail-container').html(
      new Customer.Dashboard.TicketSummaryDetailView(
        ticketSummary: @ticketSummary
      ).render().el
    )

  _renderTextView: ->
    @$('.summary-text-container').html @_textView().render().el

  _textView: ->
    switch @ticketSummary.get('summary_type')
      when 'key-value'
        new Customer.Dashboard.TicketSummaryValuesTextView
          ticketSummary: @ticketSummary
      when 'attachment'
        instagramAttachments = @ticketSummary.instagramAttachments()
        instagramStories = @ticketSummary.instagramStories()
        useVideoIcon = if instagramStories
          instagramStories[0].type == Common.AttachmentType.VIDEO
        else
          instagramAttachments.videos.length > 0
        new Customer.Dashboard.TicketSummaryAttachmentsView
          instagramAttachments: instagramAttachments
          instagramStories: instagramStories
          instagramStoriesAreExpired: @ticketSummary.areInstagramStoriesExpired()
          useVideoIcon: useVideoIcon
      else
        new Customer.Dashboard.TicketSummaryTextView
          ticketSummary: @ticketSummary

  openTicket: (event) ->
    @_keepCustomerSessionAlive()
    return @ticketSummary.open() if @ticketSummary.get 'loaded'
    Backbone.trigger 'ui:blocked'
    @_disableOpenTicketButton()
    @_fetchTicket().complete( =>
      @_enableOpenTicketButton()
      Backbone.trigger 'ui:unblocked'
    )

  _fetchTicket: ->
    new Customer.Ticket({id: @ticketSummary.id}, @ticketSummary.tags).fetch
      silent: true
      global: false
      data:
        page: 1
      success: (ticket) -> ticket.open()
      error: @_showTicketFetchError

  _disableOpenTicketButton: ->
    @$('.summary-open-ticket-button')
      .attr('disabled', true)
      .find('.summary-button-text').text(I18n.t('customer.dashboard.conversations.opening'))
      .parent().find('.fa-spinner').css('display', 'inline-block')

  _enableOpenTicketButton: ->
    @$('.summary-open-ticket-button')
      .attr('disabled', false)
      .find('.summary-button-text').text(I18n.t('customer.dashboard.conversations.open'))
      .parent().find('.fa-spinner').css('display', 'none')

  _showTicketFetchError: (ticket, response, options) ->
    if (response.status >= 500)
      showError 'An unexpected error has occurred. Please contact us if this error persists.'
      jsLogger.fatal "An error has occurred with the ticket with id: #{ticket.id}"
    else
      showError 'You no longer have access to this ticket.'

  _borderColor: ->
    window.color_for @ticketSummary.get('sub_type')

  _addReviewView: ->
    ticketSummaryReviewView = Customer.Dashboard.TicketSummaryReviewView
    if @ticketSummary.get('sub_type') == Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessReviewContent.SUB_TYPE
      ticketSummaryReviewView = Customer.Dashboard.TicketSummaryGoogleMyBusinessReviewView
    @$('#review').html(
      new ticketSummaryReviewView(
        ticketSummary: @ticketSummary
      ).render().el
    )

  _addInstagramMessageUnsupportedIcon: ->
    iconView = if @ticketSummary.isKeepconUnsupported()
      @_unsupportedByKeepconIcon()
    else
      @_unsupportedByInstagramIcon()
    @$el.find('.summary-text').prepend(iconView.render().el)

  _unsupportedByKeepconIcon: ->
    new Common.SvgIconView(
      svgPath: 'icons/unsupported-by-keepcon.svg'
      svgId: 'unsupported-by-keepcon'
      iconClass: 'unsupported-message-icon'
    )

  _unsupportedByInstagramIcon: ->
    new Common.SvgIconView(
      svgPath: 'icons/unsupported-by-instagram.svg'
      svgId: 'unsupported-by-instagram'
      iconClass: 'unsupported-message-icon'
    )

  toggleSelectTicket: (event) ->
    @_keepCustomerSessionAlive()
    @ticketSummary.toggleSelect(event.currentTarget.checked)

  toggleDisplayTicketAsSelected: (event) ->
    @$el.toggleClass('ticket-summary-selected', event.currentTarget.checked)

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'

  _scrollAttachmentsBackwards: ->
    return unless @_canScrollAttachmentsBackwards()
    @$el.find('.attachments-section .sc-attachment.d-none').last().removeClass('d-none')
    @$el.find('.attachment-scroll-backwards i').addClass('disabled') unless @_canScrollAttachmentsBackwards()
    @$el.find('.attachment-scroll-forwards i').removeClass('disabled')

  _scrollAttachmentsForwards: ->
    return unless @_canScrollAttachmentsForwards()
    @$el.find('.attachments-section .sc-attachment').not('.d-none').first().addClass('d-none')
    @$el.find('.attachment-scroll-forwards i').addClass('disabled') unless @_canScrollAttachmentsForwards()
    @$el.find('.attachment-scroll-backwards i').removeClass('disabled')

  _canScrollAttachmentsBackwards: ->
    hiddenPreviousAttachments = @$el.find('.attachments-section .sc-attachment.d-none')
    return hiddenPreviousAttachments.length > 0

  _canScrollAttachmentsForwards: ->
    attachmentSectionWidth = @_attachmentSectionVisibleWidth()
    singleAttachmentWidth = @$el.find('.attachments-section .sc-attachment').width()
    visibleAttachments = @$el.find('.attachments-section .sc-attachment').not('.d-none').length
    return (visibleAttachments * singleAttachmentWidth) > attachmentSectionWidth

  _attachmentSectionVisibleWidth: ->
    return @$el.find('.summary-text-container').width() - 140

  _displayAttachmentScroll: ->
    if @_canScrollAttachmentsForwards()
      @$el.find('.attachment-scroll-backwards').removeClass('d-none')
      @$el.find('.attachment-scroll-forwards').removeClass('d-none')
    else
      @$el.find('.attachment-scroll-backwards').addClass('d-none')
      @$el.find('.attachment-scroll-forwards').addClass('d-none')
